import { totalRepliesReceivedConfig } from '../totalRepliesReceived';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerRepliesReceivedConfig = {
    ...totalRepliesReceivedConfig,
    tooltip: null,
    orientation: ORIENTATION_VERTICAL,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
